import { motion } from "framer-motion";

export const EASE = [0.19, 1, 0.22, 1];

export function scrollToSection(id) {
  const el = document.querySelector(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72 });
  else el.scrollIntoView({ behavior: "smooth" });
}

export function Reveal({ children, delay = 0, y = 28, className = "", ...rest }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.9, delay, ease: EASE }}
      {...rest}
    >
      {children}
    </motion.div>
  );
}

export function SectionHeading({ eyebrow, title, subtitle, align = "left", light = false }) {
  const alignCls = align === "center" ? "text-center items-center" : "text-left items-start";
  return (
    <div className={`flex flex-col gap-4 ${alignCls}`}>
      <Reveal>
        <p className={`text-xs uppercase tracking-[0.22em] font-semibold ${light ? "text-[#86868b]" : "text-[#0066cc]"}`}>
          {eyebrow}
        </p>
      </Reveal>
      <Reveal delay={0.08}>
        <h2 className={`text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight leading-[1.1] ${light ? "text-white" : "text-[#1d1d1f]"}`}>
          {title}
        </h2>
      </Reveal>
      {subtitle && (
        <Reveal delay={0.16}>
          <p className={`text-lg leading-relaxed max-w-2xl ${light ? "text-[#a1a1a6]" : "text-[#86868b]"} ${align === "center" ? "mx-auto" : ""}`}>
            {subtitle}
          </p>
        </Reveal>
      )}
    </div>
  );
}
